export default "__VITE_ASSET__DkTqUWHb__"